import React, { useState, useEffect, useRef } from "react";
import { Form, Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined, EyeTwoTone } from "@ant-design/icons";

export default function SessionBaseAuthForm(props) {
  const [cookieText, setCookieText] = useState("");
  const [password, setPassword] = useState("");
  const [cookieTextError, setCookieTextError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialize form data from props
  useEffect(() => {
    if (props.authData && !isInitialized) {
      const initialCookieText = props.authData.cookieText || "";
      const initialPassword = props.authData.password || "";

      setCookieText(initialCookieText);
      setPassword(initialPassword);
      setIsInitialized(true);

      // Call validation check
      validateForm(initialCookieText, initialPassword);
    } else if (!props.authData && !isInitialized) {
      setIsInitialized(true);
      validateForm("", "");
    }
  }, [props.authData, isInitialized]);

  // Validate form and notify parent
  const validateForm = (cookieTextValue, passwordValue) => {
    const isCookieTextValid = cookieTextValue.trim() !== "";
    const isPasswordValid = passwordValue.trim() !== "";
    const isFormValid = isCookieTextValid && isPasswordValid;

    if (props.onValidationChange) {
      props.onValidationChange(isFormValid);
    }

    return isFormValid;
  };

  const handleChangeCookieText = (e) => {
    const value = e.target.value;
    setCookieText(value);
    setCookieTextError(false);

    const updatedParams = {
      cookieText: value,
      password: password,
    };

    props.handleChangeValues(updatedParams);
    validateForm(value, password);
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError(false);

    const updatedParams = {
      cookieText: cookieText,
      password: value,
    };

    props.handleChangeValues(updatedParams);
    validateForm(cookieText, value);
  };

  return (
    <div>
      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Cookies to Forward"
        required
        validateStatus={cookieTextError ? "error" : ""}
        help={cookieTextError ? "Cookies field cannot be empty" : ""}
        rules={[
          { required: true, message: "Please input cookies!" },
          {
            validator: (_, value) => {
              if (!value || value.trim() === "") {
                return Promise.reject(new Error("Cookies field cannot be empty"));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input
          value={cookieText}
          onChange={(e) => {
            const value = e.target.value;
            setCookieText(value);
            setCookieTextError(value.trim() === "");

            props.handleChangeValues({
              cookieText: value,
              password: password,
            });

            validateForm(value, password);
          }}
          disabled={props.isViewOnly}
          placeholder="Enter cookies to forward"
        />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Password"
        required
        validateStatus={passwordError ? "error" : ""}
        help={passwordError ? "Password must be at least 6 characters long" : ""}
        rules={[
          { required: true, message: "Please input password!" },
          {
            min: 6,
            message: "Password must be at least 6 characters long",
          },
        ]}
      >
        <Input.Password
          value={password}
          onChange={(e) => {
            const value = e.target.value;
            setPassword(value);
            setPasswordError(value.trim().length < 6);

            props.handleChangeValues({
              cookieText: cookieText,
              password: value,
            });

            validateForm(cookieText, value);
          }}
          disabled={props.isViewOnly}
          placeholder="Enter password"
          visibilityToggle={!props.isViewOnly && !props.isDisabled}
          iconRender={(visible) => (password.length > 0 ? visible ? <EyeInvisibleOutlined /> : <EyeOutlined /> : null)}
        />
      </Form.Item>
    </div>
  );
}
